<template>
  <div>
    <div style="text-align: right">
      <slot name="btns"></slot>
    </div>

    <el-table :data="data" height="180" class="common-el-table-styles" border style="width: 100%">
      <el-table-column width="width" label="品牌形象">
        <template slot-scope="{ row }">
          <el-radio class="profile-radio" :value="value" @change="$emit('input', row.brand_id)" :label="row.brand_id">
            {{ row.name }}
          </el-radio>
        </template>
      </el-table-column>

      <el-table-column label="头像" width="300">
        <template slot-scope="{ row }">
          <el-image
            shape="square"
            style="width: 26px; height: 26px"
            :preview-src-list="[row.image_url]"
            fit="contain"
            :src="row.image_url"
          ></el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: Array,
    value: [String, Number]
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
